module.exports = __webpack_public_path__ + "img/token-master-logo.c524171b.png";